<template>
  <svg
    version="1.1"
    id="レイヤー_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    :width="`${size}px`"
    :height="`${size}px`"
    viewBox="0 0 24 24"
    style="enable-background: new 0 0 24 24"
    xml:space="preserve"
  >
    <g id="グループ_718" transform="translate(20552.68 13798.977)">
      <g id="履歴アイコン" transform="translate(-20578.764 -13799.39)">
        <g id="グループ_682" transform="translate(26.084 2.438)">
          <path
            id="パス_102"
            :style="{
              fill: colors[0],
            }"
            d="M18.5,4.8c0-0.4-0.2-0.8-0.5-0.8H11c-0.3,0-0.5,0.3-0.5,0.8c0,0.4,0.2,0.8,0.5,0.8h6.9
				C18.2,5.6,18.5,5.3,18.5,4.8z"
          />
          <path
            id="パス_105"
            :style="{
              fill: colors[0],
            }"
            d="M18.5,10.5c0-0.4-0.2-0.8-0.5-0.8H11c-0.3,0-0.5,0.3-0.5,0.8c0,0.4,0.2,0.8,0.5,0.8h6.9
				C18.2,11.3,18.5,10.9,18.5,10.5z"
          />
          <path
            id="パス_106"
            :style="{
              fill: colors[0],
            }"
            d="M18.5,15.6c0-0.4-0.2-0.8-0.5-0.8H11c-0.3,0-0.5,0.3-0.5,0.8c0,0.4,0.2,0.8,0.5,0.8h6.9
				C18.2,16.4,18.5,16.1,18.5,15.6z"
          />
          <path
            :style="{
              fill: colors[0],
            }"
            d="M19.2-1.5H5.6C4.7-1.5,4-0.7,4,0.2v19.6c0,0.9,0.7,1.6,1.6,1.6h13.6c0.9,0,1.6-0.7,1.6-1.6V0.2
				C20.8-0.7,20.1-1.5,19.2-1.5z M20.3,19.8c0,0.6-0.5,1.1-1.1,1.1H5.6c-0.6,0-1.1-0.5-1.1-1.1V0.2c0-0.6,0.5-1.1,1.1-1.1h13.6
				c0.6,0,1.1,0.5,1.1,1.1V19.8z"
          />
        </g>
      </g>
      <circle
        id="楕円形_14"
        :style="{
          fill: colors[0],
        }"
        cx="-20544.8"
        cy="-13786.7"
        r="1.6"
      />
      <circle
        id="楕円形_14_1_"
        :style="{
          fill: colors[0],
        }"
        cx="-20544.8"
        cy="-13792.1"
        r="1.6"
      />
      <circle
        id="楕円形_15"
        :style="{
          fill: colors[0],
        }"
        cx="-20544.8"
        cy="-13781.3"
        r="1.6"
      />
    </g>
  </svg>
</template>
<script>
  export default {
    name: 'alarmOutput',
    props: {
      size: {
        type: Number,
        default: 20,
      },
      colors: {
        type: Array,
        default: () => ['#6F6F6F'],
      },
    },
  };
</script>
